import { apiFetch } from '@/shared/api/client'

export type ApiWasteLine = {
  id: string
  product_name: string
  production_date: string
  qty: number
  stock_source?: 'main' | 'return'
  reason?: string
}

export type ApiWasteBatch = {
  id: string
  code: string
  status: 'draft' | 'submitted' | 'approved' | 'rejected' | 'done'
  updated_at: string
  proposal_note?: string
  rejection_reason?: string
  lines: ApiWasteLine[]
}

export type ApiTodayWasteBatches = {
  batches: ApiWasteBatch[]
}

export async function fetchTodayWasteBatches(deviceId: string): Promise<ApiTodayWasteBatches> {
  const encoded = encodeURIComponent(deviceId)
  return apiFetch<ApiTodayWasteBatches>(`/kitchen/waste-batches/today?device_id=${encoded}`)
}
